<div class="car-main" *transloco="let t" data-test-id="right-panel.container">
  <div class="centered-content car-content">
    <div class="car-title">
      <h1 class="heading-t4 text-center" data-test-id="right-panel.heading1-txt">{{ t('rightPanel.setAGoal') }}</h1>
      <h1 class="heading-t4 text-center" data-test-id="right-panel.heading2-txt">{{ t('rightPanel.learnMore') }}</h1>
      <h1 class="heading-t4 text-center" data-test-id="right-panel.heading3-txt">{{ t('rightPanel.makeProgress') }}</h1>
      <p class="text-center mt-[4%]" data-test-id="right-panel.tagline-txt">{{ t('rightPanel.expertContent') }}</p>
    </div>
    <div class="tbox">
      <img src="/assets/images/login_new_image.png" alt="Tile Image" class="tile-image" />
    </div>
  </div>
</div>
